import { render, staticRenderFns } from "./detail-download.vue?vue&type=template&id=b5444d16&scoped=true"
import script from "./detail-download.vue?vue&type=script&lang=js"
export * from "./detail-download.vue?vue&type=script&lang=js"
import style0 from "./detail-download.vue?vue&type=style&index=0&id=b5444d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5444d16",
  null
  
)

export default component.exports